<!-- =========================================================================================
    File Name: SalesReport.vue
    Description: Sales Report table
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
  <div id="ag-grid-demo">

    <vx-card title="Sales Report" >

        <form @submit.prevent="submitForm">

            <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full mb-3">
                  <span class="text-primary text-sm vs-placeholder-label"> From Date </span>
                  <datepicker placeholder="From Date" v-model="FromDate" :format="DateFormat" ></datepicker>
                  <span class="text-danger text-sm" v-show="errors.has('FromDate')">{{ errors.first('FromDate') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                  <span class="text-primary text-sm vs-placeholder-label"> To Date </span>
                  <datepicker placeholder="To Date" v-model="ToDate" :format="DateFormat" ></datepicker>
                  <span class="text-danger text-sm" v-show="errors.has('ToDate')">{{ errors.first('ToDate') }}</span>                    
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Company RC </span>
                    <v-select v-model="CompanyRegistrationId" name="CompanyRegistrationId" :value="CompanyRegistrationId" :options="CompanyRegistrationIdOptions" label="text" :reduce="option => option.value" class="w-full" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('CompanyRegistrationId')">{{ errors.first('CompanyRegistrationId') }}</span>
                </div>                

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Taxable </span>
                    <v-select v-model="TaxableId" name="TaxableId" :value="TaxableId" :options="TaxableIdOptions" label="text" :reduce="option => option.value" v-validate="'required'" class="w-full" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('TaxableId')">{{ errors.first('TaxableId') }}</span>
                </div>                
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-3">
                  <span class="text-primary text-sm vs-placeholder-label"> Supplier Name </span>
                  <v-select v-model="PartyId" name="PartyId" :value="PartyId" :options="PartyIdOptions" label="text" :reduce="option => option.value" class="w-full" > </v-select>
                  <span class="text-danger text-sm" v-show="errors.has('PartyId')">{{ errors.first('PartyId') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                  <span class="text-primary text-sm vs-placeholder-label"> Product Group </span>
                  <v-select v-model="ProductGroupId" name="ProductGroupId" :value="ProductGroupId" :options="ProductGroupIdOptions" label="text" :reduce="option => option.value" class="w-full" > </v-select>
                  <span class="text-danger text-sm" v-show="errors.has('ProductGroupId')">{{ errors.first('ProductGroupId') }}</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full mb-3">
                  <span class="text-primary text-sm vs-placeholder-label"> Product Name </span>
                  <v-select v-model="ProductId" name="ProductId" :value="ProductId" :options="ProductIdOptions" label="text" :reduce="option => option.value" class="w-full" > </v-select>
                  <span class="text-danger text-sm" v-show="errors.has('ProductId')">{{ errors.first('ProductId') }}</span>
                </div>
            </div>
            
            <div class="vx-row">
                <div class="vx-col w-full mb-3 text-right">
                    <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2">Submit</vs-button>
                </div>
            </div>
        </form>

      <vs-divider v-if="ResultFlag == 1"/>

      <div class="vx-row text-center" v-if="EmptyResult == 1">
        <div class="vx-col w-full mb-3 text-center">
          <h4 class="text-primary" >No Sales Details found</h4>
        </div>
      </div>

      <div class="vx-row text-center" v-if="ResultFlag == 1">
        <div class="vx-col w-full mb-3 text-center">
          <h4 class="text-primary" > {{ ResultTxt }} </h4>
        </div>
      </div>      

      <vs-divider v-if="ResultFlag == 1" />

      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center" v-if="TableFlag == 1">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ rows.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : rows.length }} of {{ rows.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        </div>
      </div>
      <ag-grid-vue
        v-if="TableFlag == 1"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rows"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true">
      </ag-grid-vue>
      <vs-pagination
        v-if="TableFlag == 1"
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage" />

      <vs-divider v-if="TableFlag == 1" />

    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
// import rows from '../ui-elements/ag-grid-table/data.json'

import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

// For custom error message
import { Validator } from 'vee-validate';
import common from '@/views/Common.vue';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

const dict = {    
    custom: {        
        TaxableId: { required : 'Taxable should not be empty', },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
  mixins: [common],
  components: {
    AgGridVue,
    'v-select': vSelect,
    Datepicker    
  },
  data() {
    return {
      searchQuery: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        /*
        {
          headerName: 'Taxable',
          field: 'TaxableId',
          width: 100,
          filter: "agNumberColumnFilter",
          
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        */
        {
          headerName: 'Date',
          field: 'SalesInvoiceDateTxt',
          filter: "agDateColumnFilter",
          filterParams: {
            comparator: function(filterLocalDateAtMidnight, cellValue) {
              var dateAsString = cellValue;
              if (dateAsString == null) return -1;
              var dateParts = dateAsString.split('/');
              var cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );

              if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                return 0;
              }

              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }

              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          },
          width: 150,
          pinned: 'left'
        },
        {
          headerName: 'Invoice Number',
          field: 'SalesInvoiceNumber',
          filter: true,
          width: 250,
          pinned: 'left'
        },
        {
          headerName: 'Customer Name',
          field: 'PartyName',
          filter: true,
          width: 150,
          // pinned: 'left'
        },
        {
          headerName: 'GST Number',
          field: 'GstNumber',
          filter: true,
          width: 100,
          // pinned: 'left'
        },
        {
          headerName: 'Place Of Supply',
          field: 'PlaceOfSupply',
          filter: true,
          width: 100,
          // pinned: 'left'
        },                
        {
          headerName: 'Product Name',
          field: 'ProductDetails',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'GST (%)',
          field: 'GstSlabValue',
          filter: true,
          width: 125,
        },
        {
          headerName: 'Qty',
          field: 'Qty',
          filter: "agNumberColumnFilter",
          width: 125,
        },        
        {
          headerName: 'Price (Rs.)',
          field: 'Price',
          filter: true,
          width: 125,
        },
        {
          headerName: 'Sub Total (Rs.)',
          field: 'ProductSubTotal',
          filter: true,
          width: 125,
        },
        {
          headerName: 'SGST (Rs.)',
          field: 'ProductSgst',
          filter: true,
          width: 125,
        },
        {
          headerName: 'CGST (Rs.)',
          field: 'ProductCgst',
          filter: true,
          width: 125,
        },
        {
          headerName: 'IGST (Rs.)',
          field: 'ProductIgst',
          filter: true,
          width: 125,
        },
        {
          headerName: 'CESS (Rs.)',
          field: 'ProductCess',
          filter: true,
          width: 125,
        },
        {
          headerName: 'Amount (Rs.)',
          field: 'ProductTotal',
          filter: true,
          width: 125,
        },
      ],

      records: [],
      rows: [],

      ResultFlag:0,
      ResultTxt: '',
      EmptyResult:0,
      TableFlag: 0,

      FromDate : '',
      ToDate : '',
      CompanyRegistrationId : '',
      TaxableId: 1,
      PartyId: '',
      ProductGroupId : '',
      ProductId : '',      

      CompanyRegistrationIdOptions : [],
      TaxableIdOptions : this.selectListTrueFalse(),
      PartyIdOptions : [],
      ProductGroupIdOptions : [],
      ProductIdOptions : [],
      DateFormat: "d-MMM-yyyy",

      OpeningStock2: '',
      TotalInwardQty: '',
      TotalOutwardQty: '',
      TotalCurrentStock: ''
    }
  },
  watch: {
    '$store.state.windowWidth'(val) {
      if(val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned('email', null);
      }
      else this.gridOptions.columnApi.setColumnPinned('email', 'left')
    },
    records: function(){
      console.log('watch records');
      var temp = this.records;
      var n1=temp.length;
      console.log('n1='+n1+'temp='+JSON.stringify(temp));
      if (n1 > 0) {
        this.gridApi = this.gridOptions.api;
        this.rows = temp;
        this.EmptyResult = 0;
        this.TableFlag = 1;
        this.ResultFlag = 1;
        this.ResultTxt = n1+' Sales Invoice Details found';
      }else {
        this.TableFlag = 0;
        this.ResultFlag = 0;
        this.EmptyResult = 1;
      }
    },
    ProductGroupId: function () {
      var temp=this.ProductGroupId;
      console.log('watch ProductGroupId='+temp);
      if (temp != "") {
        var selectbox1_source = 'ProductId'
        var selectbox1_destination = 'ProductIdOptions'
        var selectbox1_url = 'lib/api/data/get_product_variant_options'
        var selectbox1_conditions_array = {
            'AllProducts': 1,
            'where':{
                "product_details_product_group_id": temp
            }            
        }
        this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);
      }
    },
    ProductIdOptions: function(){
        console.log('watch ProductIdOptions='+JSON.stringify(this.ProductIdOptions));
        var n1=this.ProductIdOptions.length;
        console.log('n1='+n1);
        if (n1 > 0) {
            var temp=this.ProductIdOptions[0];
            console.log('temp='+JSON.stringify(temp));
            var str1=this.ProductId;                
            var str2=str1.toString();
            var index = this.ProductIdOptions.map(e => e.value).indexOf(str1);
            console.log('str1='+str1+', str2='+str2+', index='+index);
            this.ProductId=index > 0 ? str2 : "";
        }
    },    
  },
  computed: {
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 50
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },
    /*
    rows() {
      return this.$store.getters['allTransaction/dataList'];
    },
    */
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    searchResult() {
      var where = {
        "FromDate": this.FromDate,
        "ToDate": this.ToDate,
        "CompanyRegistrationId": this.CompanyRegistrationId,
        "TaxableId": this.TaxableId,
        "PartyId": this.PartyId,
        "ProductGroupId": this.ProductGroupId,
        "ProductId": this.ProductId,
      };
      console.log('where='+JSON.stringify(where));
      this.getTableData('records', 'lib/api/reports/sales/sales/reports', where);      
    },
    submitForm() {
        this.$validator.validateAll().then(result => {
            if (result){
              this.searchResult();
            }else{
              console.log('form have errors');
            }
        })
    },    
  },
  beforeMount() {    
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');      
    }else{
      
      // var server_url=companyConfig.apiURL;
      
      // Load Product Group Dropdown

      var selectbox1_source = 'ProductGroupId'
      var selectbox1_destination = 'ProductGroupIdOptions'
      var selectbox1_url = 'lib/api/data/get_product_group_options'
      var selectbox1_conditions_array = {
          'product_group_id >=': 1,
      }
      this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)

      // Load Suppliers Dropdown

      var selectbox2_source = 'PartyId'
      var selectbox2_destination = 'PartyIdOptions'
      var selectbox2_url = 'lib/api/data/get_supplier_options'
      var selectbox2_conditions_array = {
          'PartyCategoryId':2,
          'where': {
              'party_details_party_category_id <=': 2
          }
      }
      this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url);

      // Load Company Registration Dropdown

      var selectbox3_source = 'CompanyRegistrationId'
      var selectbox3_destination = 'CompanyRegistrationIdOptions'
      var selectbox3_url = 'lib/api/data/get_company_registration_options'
      var selectbox3_conditions_array = {
          'where': {},
          'or_where': {}
      }
      this.getSelectBoxOptions(selectbox3_source, selectbox3_destination, selectbox3_conditions_array, selectbox3_url);

    }
  },  
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
}

</script>
